import { assignJob, getFreePopulation } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireFarmerAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.buildings.farm.qty <= 0) return false;
    const freePop = getFreePopulation(settlement);
    const cap = settlement.buildings.farm.qty;
    if (settlement.jobs.farmers >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'farmers')) return false;
    settlement.production.farm.progress.push(0);
    return true;
};
